import Scrollbars from './modules/Scrollbars';
import LazyMedia from './modules/LazyMedia';
import Devgrid from './modules/Devgrid';
import Accordion from './modules/Accordion';
import ImageExpand from './modules/ImageExpand';
import NavBackScroll from './modules/NavBackScroll';
import MobileNavToggle from './modules/MobileNavToggle';
import Chapters from './modules/Chapters';
import SectionSubNavScroll from './modules/SectionSubNavScroll';
import ShowAllCharts from './modules/ShowAllCharts'
import SlideShow from './modules/SlideShow';
import ProjectTimeline from './modules/ProjectTimeline';

import { createApp } from 'vue';
import SvgVue from 'svg-vue3';
import FilterResults from './modules/FilterResults.vue'

Scrollbars();
LazyMedia();
Devgrid();
Accordion();
ImageExpand();
Chapters();
NavBackScroll();
MobileNavToggle();
SectionSubNavScroll();
ShowAllCharts();
SlideShow();
ProjectTimeline();

const projectsWrapper = document.querySelector('#projects-filter');
const publicationsWrapper = document.querySelector('#publications-filter');
const updatesWrapper = document.querySelector('#updates-filter');

if (projectsWrapper) {
  createApp(FilterResults, {...projectsWrapper.dataset}).use(SvgVue).mount(projectsWrapper);
}
if (publicationsWrapper) {
  createApp(FilterResults, {...publicationsWrapper.dataset}).use(SvgVue).mount(publicationsWrapper);
}
if (updatesWrapper) {
  createApp(FilterResults, {...updatesWrapper.dataset}).use(SvgVue).mount(updatesWrapper);
}